import { combineReducers } from 'redux';
import { NavReducer } from 'Redux/reducers/navReducer';
import { SortAndFilterReducer } from 'Redux/reducers/sortAndFilterReducer';

export default combineReducers({
  NavReducer,
  SortAndFilterReducer,
});
